<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Sélectionner un period
      </h2>
      <span class="h4 m0">Sélectionner un period pour <span class="bold">{{ currentParticipant.firstname }} {{ currentParticipant.lastname }}</span></span>
    </div>
    <template v-if="periods && periods.length">
      <div v-for="(period, index) in periods" :key="index" class="pointer white-bg col-12 py1 px2 my2 card-top border" @click="handleClick(index)">
        <div class="col-12 flex justify-between">
          <div class="col-8 md-col-6">
            <div class="col-12 inline-block">
              <h2 class="h2 mt1 mb0">{{ period.name }}</h2>
            </div>
          </div>
          <div class="col-4 md-col-4 flex justify-end items-center xs-hide sm-hide">
          </div>
          <div class="col-2 md-col-2 flex justify-center items-center">
            <span :class="['custom-radio flex ', { 'selected-item': isSelectedPeriod(index) }]"></span>
          </div>
        </div>
      </div>
    </template>
    <h3 v-if="periods && !periods.length" class="m0">
      Aucun period
    </h3>
    <div class="flex flex-wrap">
      <div class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-6" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" class="col-4 sm-col-6 ml2" :disabled="selectedPeriod === -1" :action="confirmPeriod" text="Suivant" />
        <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/elements/Button';

import { changeToPage } from '@/utils/logics';
import { computedOfferPrices } from '@/utils/utils';

export default {
  components: { Button },
  data () {
    return {
      offer: this.$store.state.offerInfo,
      selectedPeriod: -1,
      currentParticipant: this.$store.state.currentParticipant,
      loading: false
    };
  },
  computed: {
    periods () {
      const offers = computedOfferPrices(this.currentParticipant, this.offer);

      const offerPeriods = [];

      offers.map(offer => {
        if (!offerPeriods.some(p => p.uuid === offer.period.uuid)) {
          offerPeriods.push(offer.period);
        }
      });

      return offerPeriods;
    }
  },
  created () {

  },
  methods: {
    changeToPage,
    handleBack () {
      this.changeToPage('AddParticipant');
    },
    handleClick (index) {
      this.selectedPeriod = index;
    },
    isSelectedPeriod (index) {
      return this.selectedPeriod === index;
    },
    async confirmPeriod () {
      this.loading = true;
      this.$store.commit('setSelectedPeriod', this.periods[this.selectedPeriod]);
      this.loading = false;
      this.changeToPage('Tariffs');
    }
  }
};
</script>

<style lang="scss">
  .offer-card {
    .card-top {
      padding:  2rem 4rem;

    }
    .card-bottom {
      padding: 1rem 4rem;
    }
  }
  @media (max-width: 40rem) {
    .offer-card {
      .card-top {
        padding:  1rem 2rem;

      }
      .card-bottom {
        padding: 1rem 2rem;
      }
  }
}
</style>
